import React, { useLayoutEffect, useRef } from "react";

export const ChartEntry = ({entry, active, index, playCallback, trackActivationEvent}) => {
    const ref = useRef();
    const cn = active ? 'entry active' : 'entry';
    const styles = {
        backgroundImage: `url(https://img.youtube.com/vi/${entry.ytid}/0.jpg)`
    };

    useLayoutEffect(() => {
        if (active) {
            trackActivationEvent(ref.current);
        }
    }, [active]);

    return <article className={cn} ref={ref}>
        <div className='image'
            style={styles}
            onClick={() => playCallback(index)}
        ></div>
        <div className='card-content'>
            <h1 onClick={() => playCallback(index)}>{entry.title}</h1>
            <p>Referred by {entry.vote_count} blog{entry.vote_count > 1 && 's'}</p>
        </div>
    </article>
}